import React, { useState, useEffect } from 'react';
import { Transfer } from '../../types/payment';
import { fetchProfileTransfers } from '../../services/profileService';
import DepositModal from '../Payments/DepositModal';
import WithdrawModal from '../Payments/WithdrawModal';

export default function Transfers() {
  const [transfers, setTransfers] = useState<Transfer[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [modal, setModal] = useState<'deposit' | 'withdraw' | null>(null);

  const load = () => {
    setLoading(true);
    fetchProfileTransfers()
      .then(setTransfers)
      .catch((err: any) => setError(err.message || 'Failed to load transfers'))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  return (
    <div className="profile-section">
      <div className="profile-section-header">
        <h3 className="profile-section-title">Transfers</h3>
        <div className="transfer-actions">
          <button className="btn-primary" onClick={() => setModal('deposit')}>💵 Deposit</button>
          <button className="btn-secondary" onClick={() => setModal('withdraw')}>🏦 Withdraw</button>
        </div>
      </div>

      {loading && <div className="profile-loading">Loading transfers…</div>}
      {error && <div className="profile-error">{error}</div>}
      {!loading && !error && transfers.length === 0 && (
        <p className="profile-empty">No transfers yet.</p>
      )}
      {transfers.length > 0 && (
        <table className="profile-table">
          <thead>
            <tr>
              <th>Type</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Date</th>
              <th>Tx Hash</th>
            </tr>
          </thead>
          <tbody>
            {transfers.map(t => (
              <tr key={t.id}>
                <td className="transfer-type">{t.type}</td>
                <td>${t.amount.toLocaleString('en-US', { minimumFractionDigits: 2 })} {t.currency}</td>
                <td>
                  <span className={`status-badge status-${t.status}`}>{t.status}</span>
                </td>
                <td>{new Date(t.createdAt).toLocaleDateString()}</td>
                <td className="tx-hash-cell">{t.transactionHash ?? '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {modal === 'deposit' && <DepositModal onClose={() => { setModal(null); load(); }} />}
      {modal === 'withdraw' && <WithdrawModal onClose={() => { setModal(null); load(); }} />}
    </div>
  );
}
